kwo-articles-grid {

  .tags {
    position: absolute;
    width: 100%;
    left: 0;
    top: calc(100% + 1px);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, visibility 0.3s;

    &.show {
      opacity: 1;
      visibility: visible;
    }
  }

}
